
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/editor.global.scss.css.virtualfile';
        module.exports = {"anchorHandleWidth":"140px","anchorHandleHeight":"24px","anchorHandleMarginRight":"68px"};